import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Map } from 'immutable';

import {
  ALL_BIBLIOGRAPHIC_RESOURCE_TYPES,
  BibliographicResourceType,
  STABLE_BIBLIOGRAPHIC_RESOURCE_TYPES,
} from '®shared/bibliographic-resource';
import { AppConfig } from '®shared/config';
import { EditableItem } from '®shared/reading-list';

import { ResourceTypeFilter } from './resource-type-filter';

export type ResourceTypeFilterEvent = {
  resourceTypeFilter?: ResourceTypeFilter;
};

export interface ItemCountByResourceTypeFilter {
  totalItems: number;
  itemCountByResourceType: Map<BibliographicResourceType, number>;
}

@Component({
  selector: 'rl-resource-type-filter-menu',
  templateUrl: './resource-type-filter-menu.component.html',
})
export class ResourceTypeFilterMenuComponent {
  @Input() resourceTypeFilter?: ResourceTypeFilter;
  @Input() itemCount: ItemCountByResourceTypeFilter;
  @Output() resourceTypeFilterUpdate: EventEmitter<ResourceTypeFilterEvent> =
    new EventEmitter();
  @Output() clearAll: EventEmitter<any> = new EventEmitter();

  constructor(private appConfig: AppConfig) {}

  resourceTypes: BibliographicResourceType[] = this.appConfig
    .isUnstableResourceTypesEnabled
    ? ALL_BIBLIOGRAPHIC_RESOURCE_TYPES
    : STABLE_BIBLIOGRAPHIC_RESOURCE_TYPES;

  BibliographicResourceType = BibliographicResourceType;
  isFilterLabelTruncated = false;

  private onUpdateResourceTypeFilter(resourceTypeFilter: ResourceTypeFilter) {
    this.resourceTypeFilterUpdate.emit({ resourceTypeFilter });
  }

  onFilterByResourceType(resourceType: string) {
    const resourceTypeFilter = this.getFilterForResourceType(resourceType);
    this.onUpdateResourceTypeFilter(resourceTypeFilter);
  }

  getFilterForResourceType(resourceType: string): ResourceTypeFilter {
    return {
      value: resourceType,
      predicate: (item: EditableItem) =>
        resourceType === this.getResourceTypeForItem(item),
    };
  }

  getResourceTypeForItem(item: EditableItem): string | null {
    return item.resource ? item.resource.resource_type : null;
  }

  onClearAll($event: any) {
    this.clearAll.emit($event);
  }

  onFilterLabelTruncate(isTruncated: boolean) {
    this.isFilterLabelTruncated = isTruncated;
  }
}
